/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Box } from "@mui/material";
import {
  StyledUserButton,
  StyledAccountIcon,
  NavbarActions,
  StyledMenu,
  StyledToggleButton,
  desktopImageStyles,
  mobileImageStyles,
} from "./styles";
import image from "../../assets/images/OT_only_name.png";
import mobileLogo from "../../assets/images/OT_only_logo.png"
import { ReactComponent as PrimarySidebarOpen } from "../../assets/images/primary_sidebar_open.svg";
import { FiChevronLeft } from "react-icons/fi";
import { useNotificationContext } from "../../contexts/notificationContext";
import { LoadingSpinner } from "../loading_spinner/index";
import authManager from "../../utils/authManager";
import { StyledMenuItem } from "../styled_menu_item/index"
import { GlobalSearchBar } from "../global_search_bar/index";

export default function Header({ toggleCollapse, isCollapsed, admin, isMobile }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const showNotication = useNotificationContext();
  const [loading, setLoading] = React.useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = async () => {
    setLoading(true);
    authManager.logout(true);
    showNotication("Logged out successfully", "success");
    setAnchorEl(null);
    setLoading(false);
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <Box
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            color: "black",
          }}
        >
          <img
            src={isMobile ? mobileLogo : image}
            alt={"background-image"}
            style={isMobile ? mobileImageStyles : desktopImageStyles}
          />
          <StyledToggleButton onClick={toggleCollapse}>
            {isCollapsed ? "" : <FiChevronLeft />}
            {<PrimarySidebarOpen />}
          </StyledToggleButton>
          <GlobalSearchBar isMobile={isMobile}/>
        </Box>

        <NavbarActions className="header-info" elevation={0}>
          <div>
            <StyledUserButton
              startIcon={<StyledAccountIcon />}
              onClick={handleClick}
            >
              {admin?.first_name}
            </StyledUserButton>
            <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose}>
              <StyledMenuItem onClick={handleLogOut}>
                {loading ? <LoadingSpinner isLoading={true} /> : "Log out"}
              </StyledMenuItem>
            </StyledMenu>
          </div>
        </NavbarActions>
      </div>
    </header>
  );
}
